import { useState } from "react";

import { usePostApi } from "../../../hooks";
import { createPdfHead } from "../../../mock/createPdfHead";
import {
  getPdfBody,
  getPdfSize,
} from "../../../pages/Reports/Report/Report.utils";
import { useSelector } from "../../../redux/hooks";
import { Button } from "../../shared/Button/Button";

interface Props {
  listRef: React.RefObject<HTMLDivElement>;
  lbname?: string;
}

const HistoricalSnapshotPDFButton = ({ listRef, lbname }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { post } = usePostApi();
  const handleGetPdfData = async () => {
    setIsLoading(true);

    if (listRef.current) {
      const body = await getPdfBody(listRef.current);
      const fileData = await post({
        request: "create-pdf",
        body: {
          params: {
            head: createPdfHead,
            body,
            name: `Latest_Entries_${lbname ?? "Logbook"}`,
            scale: 0.75,
            ...getPdfSize("portrait"),
          },
        },
      });
      window.open(fileData.file, "_blank");
    }

    setIsLoading(false);
  };

  return (
    <Button onClick={handleGetPdfData} loading={isLoading} variant="outline">
      Generate PDF
    </Button>
  );
};

export default HistoricalSnapshotPDFButton;
